import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getProduct } from "../../store/actions/products_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/products_enum";
import SingleView from "../../components/common/SingleView";
const ViewProduct = ({ getProduct, match, product: { loading, product } }) => {
  useEffect(() => {
    getProduct(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Products"
          mainLinkTitle="Products"
          mainLinkUrl="/products"
          activeLink="View"
        />
        {!loading ? (
          product && (
            <SingleView
              data={product}
              inputFields={inputFields}
              label="Product"
              link="products"
              id={product.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ product: state.product });

const mapDispatchToProps = { getProduct };

export default connect(mapStateToProps, mapDispatchToProps)(ViewProduct);
